module.exports = __webpack_public_path__ + "img/result.ab614f92.png";